export enum TenureType {
  LEASEHOLD = "LEASEHOLD",
  FREEHOLD = "FREEHOLD",
  UNKNOWN_OTHER = "UNKNOWN_OTHER",
}
